"use client";

import React, { useRef, useEffect } from "react";
import "./SearchDropdownPanel.css";

interface SearchDropdownPanelProps {
  children: React.ReactNode;
  isVisible: boolean;
  onClickOutside?: () => void;
  className?: string;
}

const SearchDropdownPanel: React.FC<SearchDropdownPanelProps> = ({
  children,
  isVisible,
  onClickOutside,
  className = "",
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onClickOutside?.();
      }
    };

    if (isVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isVisible, onClickOutside]);

  if (!isVisible) return null;

  const combinedClassName = ["search-dropdown-panel", className]
    .filter(Boolean)
    .join(" ");

  return (
    <div ref={ref} className={combinedClassName} data-testid="search-dropdown-panel">
      {children}
    </div>
  );
};

export default SearchDropdownPanel;
